// extracted by mini-css-extract-plugin
module.exports = {"productDeal":"az_MPc","productImg":"az_NPc","productHeader":"az_OPc","productInfo":"az_PPc","productDescription":"az_QPc","expiresData":"az_RPc","dealButton":"az_SPc"};